<template>
  <q-page class="flex flex-center">
    <div class="text-center">
      <h1 class="text-h4 text-negative">404</h1>
      <p class="text-subtitle1">Page Not Found</p>
      <q-btn
        color="primary"
        @click="$router.push('/')"
        class="q-mt-md"
      >
        Go to Home
      </q-btn>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'ErrorNotFound',
};
</script>

<style scoped>
.text-negative {
  color: var(--q-negative);
}
</style>